import React from "react";
import PropTypes from "prop-types";
import { Button, ButtonGroup } from "react-bootstrap";

import "./style.css";

function SegmentedControl({ ariaLabel, className, options, size, value, onChange }) {
    return (
        <ButtonGroup className={`segmented-control ${className || ""}`} role="group" aria-label={ariaLabel} size={size}>
            {options.map((option) => {
                const optionValue = option.value ?? option.key;
                const selected = optionValue === value;
                return (
                    <Button
                        key={optionValue}
                        type="button"
                        size={size}
                        variant={selected ? "primary" : "outline-primary"}
                        className="segmented-control-option"
                        aria-pressed={selected}
                        onClick={() => onChange(optionValue)}
                    >
                        {option.label}
                    </Button>
                );
            })}
        </ButtonGroup>
    );
}

SegmentedControl.propTypes = {
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string,
        value: PropTypes.string,
        label: PropTypes.string.isRequired
    })).isRequired,
    size: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

SegmentedControl.defaultProps = {
    ariaLabel: "Options",
    className: "",
    size: "sm"
};

export default SegmentedControl;
